import React, { useContext, useEffect } from "react";
import { GlobalContext } from "../Context/GlobalContext";

const PrivacyPolicy = () => {
  const { documentContent, getPrivacypolicy } = useContext(GlobalContext);

  useEffect(() => {
    getPrivacypolicy();
  }, [getPrivacypolicy]);

  return (
    <div className="content-part text-break" id="privacy-policy">
      <div dangerouslySetInnerHTML={{ __html: documentContent?.privacy }}></div>
    </div>
  );
};

export default PrivacyPolicy;
